<template>
  <section id="solutions" class="section solutions">
    <div class="shell">
      <div class="section-top">
        <div>
          <span class="eyebrow light-eyebrow">ВАШЕ ПРОСТРАНСТВО</span>
          <h2>Важное у каждого своё<br /><span class="muted">Решение найдётся</span></h2>
        </div>
        <p class="section-intro">
          Небольшой магазин, загородный дом или офис. Начинаем с вашей задачи, а не с количества
          камер.
        </p>
      </div>
      <div class="solution-tabs" role="tablist" aria-label="Тип объекта">
        <button
          v-for="(item, index) in solutions"
          :id="`solution-tab-${index}`"
          :key="item.tab"
          role="tab"
          :aria-selected="selected === index"
          :tabindex="selected === index ? 0 : -1"
          aria-controls="solution-panel"
          @click="selected = index"
          @keydown="onKey($event, index)"
        >
          {{ item.tab }}
        </button>
      </div>
      <div
        id="solution-panel"
        class="solution-panel"
        role="tabpanel"
        :aria-labelledby="`solution-tab-${selected}`"
        tabindex="0"
      >
        <div class="solution-photo">
          <img
            :src="`/brand/${solution.image}.webp`"
            :alt="solution.alt"
            width="1536"
            height="1024"
            loading="lazy"
          /><span class="photo-tag">{{ solution.tag }}</span>
        </div>
        <div class="solution-copy">
          <span class="tiny-label">{{ solution.label }}</span>
          <h3>{{ solution.title[0] }}<br />{{ solution.title[1] }}</h3>
          <p>{{ solution.description }}</p>
          <ul class="check-list">
            <li v-for="feature in solution.features" :key="feature">{{ feature }}</li>
          </ul>
          <NuxtLink to="/calculator" class="text-link" @click="prepare"
            >Рассчитать для моего объекта</NuxtLink
          >
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const selected = ref(0);
const { selection } = useEstimate();
const solutions = [
  {
    tab: 'Для бизнеса',
    label: 'ФОКУС НА ДЕЛЕ',
    title: ['Бизнес под контролем', 'Даже когда вы не рядом'],
    description:
      'Вход, касса, торговый зал — в одном окне. Найдите нужный момент в архиве и разберитесь в ситуации без догадок.',
    image: 'business',
    alt: 'Пример пространства небольшого магазина',
    tag: 'МАГАЗИНЫ · ОФИСЫ · НЕБОЛЬШИЕ СКЛАДЫ',
    features: [
      'Обзор ключевых зон объекта',
      'Удалённый доступ через браузер',
      'Поиск и выгрузка записей',
    ],
  },
  {
    tab: 'Для дома',
    label: 'ДОМА ВСЁ СПОКОЙНО',
    title: ['Будьте ближе к дому', 'Где бы вы ни были'],
    description:
      'Въезд, участок и входная дверь — всё в поле зрения. Посмотрите, что происходит дома, пока вы в городе или в поездке.',
    image: 'home',
    alt: 'Пример загородного дома с освещённым двором',
    tag: 'ЧАСТНЫЕ ДОМА · ДАЧИ · УЧАСТКИ',
    features: [
      'Подбор камер для улицы и помещений',
      'Запись на сервере внутри дома',
      'Проверка связи и резервного питания',
    ],
  },
  {
    tab: 'Уже есть камеры',
    label: 'НОВЫЙ ВЗГЛЯД НА ВАШУ СИСТЕМУ',
    title: ['Камеры уже есть?', 'Объединим возможности'],
    description:
      'Проверим ваше оборудование и предложим переход на Robotics Vision. Сохраним подходящие камеры и настроим удобный доступ к архиву.',
    image: 'camera',
    alt: 'IP-камера видеонаблюдения',
    tag: 'ПРОВЕРКА · ПОДКЛЮЧЕНИЕ · НАСТРОЙКА',
    features: [
      'Проверка моделей и RTSP-потоков',
      'Оценка сети и сервера',
      'План перехода с сохранением записи',
    ],
  },
];
const solution = computed(() => solutions[selected.value]);
function prepare() {
  selection.value.object = selected.value === 1 ? 'home' : 'business';
  if (selected.value === 2) selection.value.cameras = 'custom';
}
function onKey(event: KeyboardEvent, index: number) {
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  event.preventDefault();
  selected.value =
    event.key === 'Home'
      ? 0
      : event.key === 'End'
        ? 2
        : (index + (event.key === 'ArrowRight' ? 1 : -1) + 3) % 3;
  nextTick(() => document.getElementById(`solution-tab-${selected.value}`)?.focus());
}
</script>
